import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface PanelProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
}

/** Panel canónico del Design System (F2) — agrupa contenido con encabezado opcional. Sucesor de ClinicalSection. */
export function Panel({ title, description, actions, children, className, noPadding }: PanelProps) {
  return (
    <section className={cn("overflow-hidden rounded-xl border border-border bg-card", className)}>
      {title ? (
        <div className="flex flex-wrap items-start justify-between gap-3 border-b border-border bg-muted/50 px-card-padding py-4">
          <div>
            <h3 className="text-headline-md font-semibold text-foreground">{title}</h3>
            {description ? <p className="mt-0.5 text-body-md text-muted-foreground">{description}</p> : null}
          </div>
          {actions}
        </div>
      ) : null}
      <div className={cn(!noPadding && "p-card-padding")}>{children}</div>
    </section>
  );
}
